import { LOAD_FIRST_COVER_TO_BACKGROUND_TYPE } from '../../action-types/ui/loadFirstCoverToBackgroundType';

export const STATE_KEY = 'loadCoverToBGType';

export const loadCoverToBGType = flag => ({
  type: LOAD_FIRST_COVER_TO_BACKGROUND_TYPE,
  flag,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/loadFirstCoverToBackgroundType.js